import { createSlice, createAction } from '@reduxjs/toolkit';
import initialState from '../../../domain/entities/survey';

function registerResponsesSuccess(state, action) {
  const { code, message } = action.payload;
  state.registerResponses = {
    success: true,
    error: false,
    code,
    message,
  };
}

function registerResponsesError(state, action) {
  const { code, message } = action.payload;
  state.registerResponses = {
    success: false,
    error: true,
    code,
    message,
  };
}

const registerResponses = createAction('registerResponses');

const surveyReducer = createSlice({
  name: 'survey',
  initialState,
  reducers: {
    registerResponsesSuccess,
    registerResponsesError,
  },
});

export const surveyActions = { ...surveyReducer.actions, registerResponses };

export default surveyReducer.reducer;
